import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from "@nuxtjs/composition-api";

import { useCartsStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'CartItemsList',
  props: {
  cartId: {
    type: String,
    required: true,
  },
},
  emits: ["showLoadingOverlay"],
  setup(__props, { emit }: { emit: ({
  (e: "showLoadingOverlay", show: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const { cartId } = toRefs(props);

const cartsStore = useCartsStore();

const cartItemIds = computed(() => {
  return cartsStore.carts[cartId.value]?.cartItemIds ?? [];
});

const onDeleteCartItem = async (cartItemId: string) => {
  emit("showLoadingOverlay", true);
  await cartsStore.deleteCartItem({ ids: [cartItemId] });
  emit("showLoadingOverlay", false);
};

const onUpdateCartItemQuantity = async ({ cartItemId, quantity }: { cartItemId: string; quantity: number }) => {
  emit("showLoadingOverlay", true);
  await cartsStore.updateCartItem({ cartItemId, quantity });
  emit("showLoadingOverlay", false);
};

return { __sfc: true,emit, props, cartId, cartsStore, cartItemIds, onDeleteCartItem, onUpdateCartItemQuantity }
}

})